module.exports = __webpack_public_path__ + "img/1.53894ea1.jpg";